<template>
    <div id="companies">
        <v-container>
            <v-row class="text-center">
                <v-col cols="12">
                    <v-btn @click="goBack" color="primary"><v-icon dark left>mdi-arrow-left</v-icon> zurück</v-btn>
                </v-col>
                <v-col cols="12">
                    <h2>Betriebe / Kategorie: <span>{{ category }}</span></h2>
                </v-col>
            </v-row>
            <v-row class="text-center">
                <v-col cols="12">
                    <div v-if="companies.length > 0">
                        <ul class="companies-wrapper">
                            <li v-for="item in companies" :key="item.id">
                                <div class="inner">
                                    <h3><router-link :to="{ name: 'betrieb-detail', params: {id: item.id} }" class="title">{{ item.title }}</router-link></h3>
                                    <p>{{ item.street }}<br>
                                        {{ item.postcode }} {{ item.city }}<br>
                                        <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                                        <span v-if="item.web"><br><a :href="`${item.web}`" target="_blank">{{ item.web }}</a></span>
                                        <span v-if="item.phone"><br><a :href="`tel:${item.phone}`">{{ item.phone }}</a></span>
                                        <span v-if="item.mobile"> &bull; <a :href="`tel:${item.mobile}`">{{ item.mobile }}</a></span>
                                    </p>
                                    <p v-if="item.shop">
                                        <strong>Online Shop:</strong><br>
                                        <a :href="`${item.shop}`" target="_blank">{{ item.shop }}</a>
                                    </p>
                                    <p v-if="item.tags" class="tags">
                                        {{ item.tags }}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <p>Keine Betriebe vorhanden.</p>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { dataService } from "../shared";
    import { navigation } from "../mixins/navigation";

    export default {
        name: "Companies",
        props: ['id', 'title'],
        mixins: [navigation],
        data() {
            return {
                companies: {}
            }
        },
        methods: {
            async load()
            {
                this.companies = await dataService.getCompanies(this.id);
            },
        },
        async created() {
            await this.load();
        },
        computed: {
            category() {
                return this.title;
            }
        }
    }
</script>

<style scoped>

</style>